module.exports = __webpack_public_path__ + "img/solution1.42e6e24e.jpg";